import React, { useState } from 'react';
import { useDebugModeStore } from '~/stores/debug';

import CSS from './VersionNumber.module.scss';

const APPLICATION_VERSION = withlocals_version;
const DEFAULT_VERSION_TEXT = `version ${APPLICATION_VERSION}`;

function VersionNumber() {
  const debugModeStore = useDebugModeStore();
  const [clickCount, setClickCount] = useState(0);
  const [versionText, setVersionText] = useState(DEFAULT_VERSION_TEXT);

  const handleClick = () => {
    const newClickCount = clickCount + 1;
    if (newClickCount > 2) {
      setVersionText(
        `Click ${7 - newClickCount} more times to activate debug mode.`,
      );
    }
    if (newClickCount === 7) {
      debugModeStore.setDebugMode(true);
      setClickCount(0);
      setVersionText(DEFAULT_VERSION_TEXT);
    } else {
      setClickCount(newClickCount);
    }
  };

  if (!APPLICATION_VERSION) {
    return null;
  }

  return (
    <div className={CSS.VersionNumber} onClick={handleClick}>
      {versionText}
    </div>
  );
}

export default VersionNumber;
